import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-datasource';
import { IAppointmentLocationsOrganizersDatasource } from '../datasources/appointment_location_staff_datasource';
import { AppointmentUsersourceServant } from '../servants/appointments_usersource_servant';
import { ICourse } from '../types/appointment_interfaces';
import { IAppointmentType, IStudentService } from '../types/appointment_interfaces';
import { ILocation, IOrganizer } from '../types/appt_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

interface IAppointmentsOrganizersResult1 {
  organizersList: IOrganizer[];
  organizersInstructions: string;
  hasOrganizers: boolean;
  errorMessage: string;
  isAllowedToChooseOrganizer: boolean;
  showOrganizers: boolean;
  blockedReason: string;
  showBlockedReason: boolean;
}

export class AppointmentsOrganizersQuery1 implements IQuery {
  private _result: IAppointmentsOrganizersResult1;

  constructor(
    private ngAppointmentLocationsOrganizersDatasource: IAppointmentLocationsOrganizersDatasource,
    private ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    private ngAppointmentUsersourceServant: AppointmentUsersourceServant
  ) {
    ORMMediator.registerQuery(
      this,
      ngAppointmentLocationsOrganizersDatasource,
      ngAppointmentLocationsOrganizersUsersource
    );
  }

  private __getOrganizersList(organizers: IOrganizer[], selectedType: IAppointmentType) {
    return _4.map(organizers, (organizer: IOrganizer) => ({
      ...organizer,
      advisorLabel: organizer.parent_of_student ? `(Your ${selectedType.organizer_name})` : ''
    }));
  }

  run(): this {
    const selectedType = this.ngAppointmentReasonUsersource.read().selectedType;
    if (!!selectedType.instructions) {
      const organizersInstructions = selectedType.instructions.staff;
      const errorMessage = selectedType.instructions.organizers_error
        ? selectedType.instructions.organizers_error
        : selectedType.instructions.location_error;
      const selectedLocation = this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation;
      const selectedCourse = this.ngAppointmentLocationsOrganizersUsersource.read().selectedCourse;

      let organizersList: IOrganizer[] = [];
      let hasOrganizers = false;
      let isAllowedToChooseOrganizer = true;

      const can_request: boolean = selectedLocation.can_request;
      const is_blocked: boolean = selectedLocation.is_blocked ? selectedLocation.is_blocked : false;
      const blockedReason = selectedLocation.blocked_reason ? selectedLocation.blocked_reason : '';
      const can_view_dropins = selectedLocation.can_view_dropins;

      const showBlockedReason = is_blocked && !can_request && !can_view_dropins;

      const showOrganizers =
        _4.gt(selectedCourse.id, 0) || (!selectedLocation.include_courses && _4.gt(selectedLocation.id, 0));

      if (selectedLocation.id && !selectedLocation.include_courses) {
        isAllowedToChooseOrganizer = this.ngAppointmentUsersourceServant.isUserAllowedRoChooseOrganizer;
        organizersList = this.__getOrganizersList(
          selectedLocation.organizers as IOrganizer[],
          selectedType
        ) as IOrganizer[];
        organizersList = _4.orderBy(organizersList, ['advisorLabel', 'id'], ['desc', 'asc']);
        hasOrganizers = organizersList.length > 0;
      } else if (selectedCourse.id && selectedLocation.include_courses) {
        isAllowedToChooseOrganizer = this.ngAppointmentUsersourceServant.isUserAllowedRoChooseOrganizer;
        organizersList = this.__getOrganizersList(selectedCourse.organizers, selectedType) as IOrganizer[];
        organizersList = _4.orderBy(organizersList, ['advisorLabel', 'id'], ['desc', 'asc']);
        hasOrganizers = organizersList.length > 0;
      }
      this._result = {
        organizersList,
        organizersInstructions,
        errorMessage,
        hasOrganizers,
        isAllowedToChooseOrganizer,
        showOrganizers,
        blockedReason,
        showBlockedReason
      };
    }
    return this;
  }

  get result(): IAppointmentsOrganizersResult1 {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/queries/appointments_organizers_query.ts